import {ActivityIndicator} from "react-native";
import Page from "@/lib/pages/Page";
import {Color} from "@/lib/styles";
import Center from "@/lib/components/Center";
import Header from "@/lib/components/Header";

type SpinnerPageProps = {
    title?: string;
}

// Outer wrapper container for all pages.
export default function SpinnerPage(props: SpinnerPageProps) {
    return (
        <Page>
            <Center>
                <ActivityIndicator size="large" color={Color.PrimaryText}/>
                {props.title &&
                    <Header title={props.title} center={true}/>
                }
            </Center>
        </Page>
    );
}